import Cookies from "js-cookie";
// import { useState } from "react";
// const [isLoggedIn, setIsLoggedIn] = useState(false);

export const getTokenLocal = () => {
  return Cookies.get("paraAdmin_auth_token");
};

export const getUserLocal = () => {
  const user = Cookies.get("para-admin_ufo");

  if (user !== null && user !== undefined) {
    return JSON.parse(user);
    // setIsLoggedIn(true);
  } else {
    return null;
    // setIsLoggedIn(false);
  }
};

export const setTokenLocal = (token) => {
  Cookies.set("paraAdmin_auth_token", token, { expires: 30 });
  // console.log(Cookies.set("paraAdmin_auth_token", token, { expires: 30 }));
};

export const setUserLocal = (user) => {
  Cookies.set("para-admin_ufo", JSON.stringify(user), { expires: 30 });
};